import styled from 'styled-components';

export const FlightFareChart = styled.div`
  border-radius: 6px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e6e6e6;
  padding: ${props => props.theme.spacing.custom(10)};
  margin: ${props => props.theme.spacing.custom(10)} 0;
  background-color: #ffffff;
`;

export const RouteHd = styled.div`
  font-size: 1.8rem;
`;

export const RouteBook = styled.div`
  width: 100px;
`;

export const BookButton = styled.button`
  background-color: #ff6d38;
  border-radius: 0.5rem;
  outline: none;
  padding: ${props => props.theme.spacing.custom(7)} 0;
  color: #ffffff;
  text-transform: uppercase;
  border: none;
  font-weight: 500;
  font-size: ${props => props.theme.font.custom(16)};
  /* width:85%; */
  cursor: pointer;
`;

export const FlightsRoute = styled.div`
  @media (max-width: 768px) {
    & {
      padding: 0 1rem;
    }
  }
  width: 100%;
  a {
    outline: none;
    text-decoration: none;
    color: #2c67b3;
  }
  a:hover {
    color: #f46913;
  }
`;
